import React, { Component, Fragment } from 'react';

import DesktopRepeat from './Desktop/DesktopRepeat';
import MobileRepeat from './Mobile/MobileRepeat';

export default class Repeat extends Component {
  render() {
    const { openRepeat, selectedRepeat, repeat, repeats, closeRepeat } = this.props;
    let repeatt;
    if (window.innerWidth > 900) {
      repeatt = <DesktopRepeat
        openRepeat={openRepeat}
        selectedRepeat={selectedRepeat}
        repeats={repeats}
        repeat={repeat}
        closeRepeat={closeRepeat}
      />;
    }
    else if (window.innerWidth < 900) {
      repeatt = <MobileRepeat
        openRepeat={openRepeat}
        selectedRepeat={selectedRepeat}
        repeats={repeats}
        repeat={repeat}
        closeRepeat={closeRepeat}
      />;
    }
    return (
      <Fragment>
        {
          repeatt
        }
      </Fragment>
    );
  }
}